import usePlaceAutocomplete from 'hooks/usePlaceAutocomplete'

const EMPTY_PARAMS = {}

export default function useAgentHubAddressAutocomplete(textInput: string) {
  const { predictions, isLoading } = usePlaceAutocomplete(textInput, EMPTY_PARAMS)
  return { predictions, isLoading }
}
